import React from "react";
import styled from "styled-components";
import { FaStar } from "react-icons/fa";

const Band = styled.div`
  margin: 32px auto 0; padding: 18px 0; text-align: center;
  color: ${({theme})=>theme.colors.text.secondary};
  .stars { display:inline-flex; gap: 4px; transform: translateY(2px); margin-right: 8px; color: #FFD700; }
  strong { color: ${({theme})=>theme.colors.text.primary}; }
`;

export default function SocialProof(){
  return (
    <Band className="container">
      <span className="stars">
        {[...Array(5)].map((_,i)=><FaStar key={i} />)}
      </span>
      <strong>4.9/5 average</strong> from 500+ local families • "On time, spotless, and super friendly!"
    </Band>
  );
}
